import React, { useEffect, useState, useRef } from "react";
import "./Area.scss";
import { useScrollBoost } from "react-scrollbooster";
import Cover from "../Cover/Cover";
import DragInfo from "../DragInfo/DragInfo";
import AmenitiesGMap from "../AmenitiesGMap/AmenitiesGMap";
import { useSelector } from "react-redux";
import MobileFooter from "../MobileFooter/MobileFooter";

var mouseX = 0;

const Area = (props) => {
    const content = useSelector((state) => state.content.pages.area);
    const dragInfo = useRef();
    const [canScroll, setCanScroll] = useState(true);
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    var mapContainer = useRef();
    var canScrollContainer = useRef();

    function checkShouldScroll(e) {
        //basically just need to port the function up there over here because it worekd before
        //now we check the window stuff
        if (window.innerWidth >= 1024 && window.innerHeight >= 600) {
            const mapRect = canScrollContainer.current.getBoundingClientRect();
            const boundsRect = mapContainer.current.getBoundingClientRect();
            if (boundsRect.right <= window.innerWidth) {
                //now that we did all that mouse stuff check if the mouse is inside of the map container
                //if so we will not be scrolling sorry
                if (mouseX >= mapRect.left + 56) {
                    return false;
                }
            }
        }

        return true;
    }

    function hideDragInfo() {
        if (props.underViewport.current.scrollLeft > 40) {
            dragInfo.current.style.opacity = "0";
        } else {
            dragInfo.current.style.opacity = "1";
        }
    }

    function updateMousePosition(e) {
        mouseX = e.pageX;
    }

    useEffect(() => {
        function scrollWheelTurned(e) {
            //e.stopPropogation();
            //e.preventDefault();

            if (typeof props.underViewport.current != "undefined") {
                if (checkShouldScroll(e))
                    props.underViewport.current.scrollLeft += e.deltaY;
            }
        }

        window.addEventListener("wheel", scrollWheelTurned);

        return () => {
            window.removeEventListener("wheel", scrollWheelTurned);
        };
    });

    useEffect(() => {
        window.scrollTo(0, 0);

        window.addEventListener("mousemove", updateMousePosition);

        return () => {
            window.removeEventListener("mousemove", updateMousePosition);
        };
    }, []);

    const mergeRefs = (...refs) => {
        const filteredRefs = refs.filter(Boolean);
        if (!filteredRefs.length) return null;
        if (filteredRefs.length === 0) return filteredRefs[0];
        return (inst) => {
            for (const ref of filteredRefs) {
                if (typeof ref === "function") {
                    ref(inst);
                } else if (ref) {
                    ref.current = inst;
                }
            }
        };
    };

    if (typeof content !== "undefined") {
        return (
            <div
                //ref={mergeRefs(viewport, props.areaViewport)}
                ref={props.areaViewport}
                className="area-viewport"
                onScroll={hideDragInfo}
            >
                <div
                    className={`area${isTouchScreen ? " touchscreen" : ""}`}
                    ref={props.underViewport}
                >
                    {/*<Cover /> */}
                    <DragInfo reference={dragInfo} />
                    <div id="image-load-target">
                        {content.use_overview && (
                            <div
                                className="area-overview-section area-section"
                                id="overview"
                                ref={props.overview}
                            >
                                <div className="content">
                                    <div className="left-section">
                                        <h2 className="heading">
                                            {content.overview.heading}
                                        </h2>
                                        <div className="image-wrapper">
                                            <img
                                                className="image"
                                                src={
                                                    content.overview
                                                        .heading_large_image.url
                                                }
                                            />
                                            <img
                                                className="decoration"
                                                src={
                                                    content.overview
                                                        .heading_small_image.url
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="middle-image-section">
                                        <div className="image-wrapper">
                                            <img
                                                src={
                                                    content.overview
                                                        .copy_bottom_image.url
                                                }
                                                className="middle-image"
                                            />
                                            <img
                                                src={
                                                    content.overview
                                                        .copy_top_image.url
                                                }
                                                className="decoration"
                                            />
                                        </div>
                                    </div>
                                    <div className="right-content-section">
                                        <p className="copy">
                                            {content.overview.copy}
                                        </p>
                                        <img
                                            className="overlapped-image"
                                            src={content.overview.flowers.url}
                                        />
                                    </div>
                                </div>
                                <img
                                    className="large-display-image"
                                    src={content.overview.display_image.url}
                                />
                            </div>
                        )}
                    </div>
                    {content.use_trails && (
                        <div
                            className="area-trails-section area-section"
                            id="trails"
                            ref={props.trails}
                        >
                            <div className="section-lake">
                                <div className="content">
                                    <h1
                                        className="heading"
                                        dangerouslySetInnerHTML={{
                                            __html: content.trails.heading,
                                        }}
                                    />
                                    <img
                                        src={content.trails.decoration.url}
                                        className="image"
                                    />
                                    <p className="copy">
                                        {content.trails.copy}
                                    </p>
                                </div>
                                <div className="image-wrapper">
                                    <img
                                        src={content.trails.map.url}
                                        className="large-image"
                                    />
                                </div>
                            </div>
                            {false && (
                                <div className="section-convenient">
                                    <div className="content">
                                        <div className="top-row">
                                            <h1
                                                className="heading"
                                                dangerouslySetInnerHTML={{
                                                    __html: content.trails
                                                        .glasco.heading,
                                                }}
                                            />
                                            <div className="image-wrapper">
                                                <img
                                                    src={
                                                        content.trails.glasco
                                                            .right_image.url
                                                    }
                                                    className="image"
                                                />
                                                <img
                                                    className="decoration"
                                                    src={
                                                        content.trails.glasco
                                                            .right_decoration
                                                            .url
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="bottom-row">
                                            <img
                                                src={
                                                    content.trails.glasco
                                                        .left_image.url
                                                }
                                                className="image"
                                            />
                                            <p className="copy">
                                                {content.trails.glasco.copy}
                                            </p>
                                        </div>
                                    </div>
                                    <img
                                        className="large-image"
                                        src={
                                            content.trails.glasco.large_image
                                                .url
                                        }
                                        alt={
                                            content.trails.glasco.large_image
                                                .alt
                                        }
                                    />
                                </div>
                            )}

                            <div className="section-connections">
                                <div className="content">
                                    <div className="image-wrapper">
                                        <img
                                            src={
                                                content.trails.boyd_nature
                                                    .copy_image.url
                                            }
                                            className="image"
                                        />
                                        <img
                                            src={
                                                content.trails.boyd_nature
                                                    .bird_image.url
                                            }
                                            className="overlap"
                                        />
                                    </div>
                                    <p className="copy">
                                        {content.trails.boyd_nature.copy}
                                    </p>
                                    <h1 className="heading">
                                        <span className="first">
                                            {
                                                content.trails.boyd_nature
                                                    .heading.first
                                            }
                                        </span>
                                        <span className="second">
                                            {
                                                content.trails.boyd_nature
                                                    .heading.second
                                            }
                                        </span>
                                    </h1>
                                </div>
                                <img
                                    src={
                                        content.trails.boyd_nature.large_image
                                            .url
                                    }
                                    className="large-image"
                                    alt={
                                        content.trails.boyd_nature.large_image
                                            .alt
                                    }
                                />
                            </div>
                        </div>
                    )}
                    {content.use_area && (
                        <div
                            className="area-places-section"
                            id="area"
                            ref={props.area}
                        >
                            <div className="content">
                                <div className="heading-wrapper">
                                    <h1 className="heading">
                                        {content.area.heading}
                                    </h1>
                                    <img
                                        className="underline"
                                        src={content.area.heading_underline.url}
                                    />
                                </div>
                                <p className="copy">{content.area.copy}</p>
                                <img
                                    className="display-image"
                                    src={content.area.flower.url}
                                />
                            </div>
                            <div className="gallery-container">
                                {content.area.gallery.map((img, key) => (
                                    <div className="gallery-image">
                                        <img
                                            className="image"
                                            src={img.image.url}
                                            alt={img.image.alt}
                                        />
                                        <div className="heading">
                                            {img.heading}
                                        </div>
                                        <p className="copy">{img.copy}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {content.use_map && (
                        <div
                            className="section-g-map"
                            id="amenities"
                            ref={props.amenities}
                        >
                            {
                                <AmenitiesGMap
                                    scrollLock={setCanScroll}
                                    map={content.map}
                                    blank={content.blank_map_image}
                                    reference={mapContainer}
                                    canScrollRef={canScrollContainer}
                                    //scrollBooster={viewport}
                                />
                            }
                        </div>
                    )}
                    <MobileFooter showBelow={1024} />
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
};

export default Area;
